import React, { useEffect, useState } from "react";
import UserHeader from "../users/components/header/UserHeader";
import ChatBotBox from "../users/templates/chatbot/ChatBotBox";
import Footer from "../users/components/footer/Footer";
import { TbArrowBigUpLinesFilled } from "react-icons/tb";
import { handleTopScroll } from "../common/function/ScroolTop";
import { AnimatePresence, motion } from "motion/react";

const PublicLayout = ({ children }) => {
  const [scrollStatus, setScrollStatus] = useState(false);
  const [scrollDirection, setScrollDirection] = useState(null);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);
  const publicPathsWithoutHeader = [
    "/admin",
    "/forgotpassword",
    "/emailverify",
    "*",
  ];

  const newpath = "/confirmPassword";

  const currentPath = window.location.pathname;

  const status = currentPath.includes(newpath);

  const showHeader = !publicPathsWithoutHeader.includes(currentPath);

  const handleScroll = () => {
    const id = document.getElementById("topScrool");
    const currentScrollPosition = id ? id.scrollTop : 0;

    if (currentScrollPosition >= 300) {
      if (currentScrollPosition > lastScrollPosition) {
        setScrollStatus(false);
      } else if (currentScrollPosition < lastScrollPosition) {
        setScrollStatus(true);
      }
      setLastScrollPosition(currentScrollPosition);
    } else {
      setScrollStatus(false);
    }
  };

  useEffect(() => {
    const id = document.getElementById("topScrool");
    id.addEventListener("scroll", handleScroll);

    return () => {
      id.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollPosition]);

  return (
    <div id="topScrool" className="realtive h-screen  w-full overflow-x-hidden">
      {status || (showHeader && <UserHeader />)}
      {children}

      {status || (showHeader && <Footer />)}
      {/* <div className="fixed bottom-12 right-8">
        {status || (showHeader && <ChatBotBox />)}
      </div> */}
      <AnimatePresence>
        {scrollStatus && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            onClick={handleTopScroll}
            className="fixed bottom-1.5 left-3 bg-speed-red p-3 rounded-full cursor-pointer"
          >
            <TbArrowBigUpLinesFilled className="text-white font-semibold w-6 h-6" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PublicLayout;
